// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = () => {
  const location = useLocation();

  // Check if user is authenticated with valid token
  if (!isAuthenticated()) {
    console.log("[PROTECTED ROUTE] User not authenticated, redirecting to login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  console.log("[PROTECTED ROUTE] User authenticated, rendering protected route:", location.pathname);
  return <Outlet />;
};

export default ProtectedRoute;
